<template>
  <div class="video-fixed">
    <div class="full-screen-video" ref="videoBox">
      <video
        id="my-player"
        ref="videoPlayer"
        class="video-js vjs-big-play-centered"
        playsinline="true"
        x5-playsinline="true"
        webkit-playsinline="true"
        disablePictureInPicture
      >
        <source ref="videoSource" :src="src" type="video/mp4" />
      </video>
    </div>
  </div>
</template>
<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  name: "FullScreenVideo",
  props: {},
  data() {
    return {
      src: "",
      player: null,
      options: {
        controls: true,
        autoplay: true,
        fluid: true, // 自适应宽高
        language: "zh-CN", // 设置语言
        muted: false, // 是否静音
      },
      isMobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/),
      videoIsHorizontal: true,
      isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      bodyHeight: "100%",
      bodyWidth: "100%",
      isHorizontal: false,
      needRotate: true,
      playing: false,
      videoHeight: 0,
      videoWidth: 0,
    };
  },
  created() {
    this.src = this.$route.query.url;
  },
  mounted() {
    if (this.src) {
      this.initObserver();
      this.initVideos();
    } else {
      this.$toast.show({
        showTime: 2,
        message: "请检查参数是否正确",
        style: "error",
      });
    }
  },
  methods: {
    initVideos() {
      this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        this.onPlayerReady
      );
    },
    onPlayerReady() {
      const modalDiv = document.createElement("div");
      modalDiv.className = "logoModalRight";
      modalDiv.id = "ModalRightDivId";
      document.getElementById("my-player").appendChild(modalDiv);
      this.player.on("loadedmetadata", () => {
        const videoDom = document.getElementById("my-player_html5_api");
        this.videoWidth = videoDom.videoWidth;
        this.videoHeight = videoDom.videoHeight;
        this.videoIsHorizontal = this.videoWidth > this.videoHeight;
        console.log(11, this.videoWidth, this.videoHeight);
        this.needRotate = !this.videoIsHorizontal
          ? false
          : !this.isHorizontal && this.isIOS;
        this.updateLogoModal();
        !this.isIOS && this.isMobile && this.player.requestFullscreen();
        this.playing = true;
        this.player.play();
      });
      this.player.on("fullscreenchange", () => {
        if (this.isFullScreen) {
          this.player.pause();
          this.playing = false;
        }
        this.isFullScreen = !this.isFullScreen;
      });
      this.player.on("error", () => {
        this.playing = false;
      });
      this.fullScreenHijack();
    },
    fullScreenHijack() {
      const fullScreenButton = document.getElementsByClassName(
        "vjs-fullscreen-control"
      )[0];
      // 退出全屏
      if (!this.isIOS && this.isMobile) {
        // 安卓直接使用自带全屏功能，不需特殊处理
        fullScreenButton.addEventListener(
          "touchend",
          () => {
            this.player.pause();
            this.playing = false;
          },
          true
        );
        return;
      }

      if (fullScreenButton) {
        if (this.isMobile) {
          fullScreenButton.addEventListener(
            "touchend",
            (event) => {
              event.preventDefault();
              event.stopPropagation();
              fullScreenButton.pause();
              this.playing = false;
            },
            true
          );
        } else {
          fullScreenButton.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              event.stopPropagation();
              fullScreenButton.pause();
              this.playing = false;
            },
            true
          );
        }
      }
    },
    // 初始化观察者，监听body变化
    initObserver() {
      let timer = null;
      const myObserver = new ResizeObserver((entries) => {
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
          // step1、针对 IOS，重新计算是否需要旋转（为了兼容IOS本身的自带的屏幕旋转功能）
          if (this.isIOS) {
            const entry = entries[0];
            const { width, height } = entry?.contentRect;
            this.bodyHeight = height + "px";
            this.bodyWidth = width + "px";
            this.isHorizontal = width > height;
            this.needRotate = !this.videoIsHorizontal ? false : width < height;
            console.log("needRotate", this.needRotate);
          } else {
            this.needRotate = false;
            this.isHorizontal = false;
          }
          // step2、屏幕尺寸发生变化时，重新计算水印的遮罩大小（特别是PC端调整创建大小）
          this.updateLogoModal();
          this.styleComputed();
        }, 100);
      });
      myObserver.observe(document.body);
    },
    // 更新logo遮罩层范围
    updateLogoModal() {
      const rightDom = document.getElementById("ModalRightDivId");
      // 安卓公众号全屏播放时，屏幕高度（因为旋转，此时应该是宽度）会缩小,但小程序又不一样
      const bodyHeight = document.body.offsetHeight;
      const bodyWidth = document.body.offsetWidth;
      // console.log(this.needRotate, this.videoWidth, this.videoHeight);
      const scaleW = this.needRotate
        ? bodyHeight / this.videoWidth
        : bodyWidth / this.videoWidth;
      const scaleH = this.needRotate
        ? bodyWidth / this.videoHeight
        : bodyHeight / this.videoHeight;
      const scale = Math.min(scaleW, scaleH); // 视频最终的缩放比例
      const videoShowWidth = this.videoWidth * scale; // 视频显示的实际宽度
      const videoShowHeight = this.videoHeight * scale; // 视频显示的实际高度
      const videoParentWidth = this.needRotate ? bodyHeight : bodyWidth; // 视频组件的父级dom，置放modal的节点，宽度
      const videoParentHeight = this.needRotate ? bodyWidth : bodyHeight; // 视频组件的父级dom，置放modal的节点，高度
      // 水印图片信息（相对于1280宽/高的视频）
      // 放大10px的大小
      const waterMark = {
        width: 240 * scale + 10,
        height: 80 * scale + 10,
        right: 40 * scale - 5,
        top: 30 * scale - 5,
      };
      // 修正偏移量
      waterMark.right += (videoParentWidth - videoShowWidth) / 2;
      waterMark.top += (videoParentHeight - videoShowHeight) / 2;
      if (rightDom) {
        rightDom.style.width = waterMark.width + "px";
        rightDom.style.height = waterMark.height + "px";
        rightDom.style.right = waterMark.right + "px";
        rightDom.style.top = waterMark.top + "px";
      }
    },
    styleComputed() {
      let rotateStyle = "";
      if (this.needRotate) {
        const halfWidth = Number(this.bodyWidth.replace("px", "")) / 2 + "px";
        rotateStyle = `transform:rotate(90deg);transform-origin: ${halfWidth} ${halfWidth}`;
        document.documentElement.style.setProperty(
          "--videoWidth",
          this.bodyHeight
        );
        document.documentElement.style.setProperty(
          "--videoHeight",
          this.bodyWidth
        );
      } else {
        document.documentElement.style.setProperty(
          "--videoWidth",
          this.bodyWidth
        );
        document.documentElement.style.setProperty(
          "--videoHeight",
          this.bodyHeight
        );
      }
      rotateStyle = this.needRotate
        ? `width: ${this.bodyHeight};height: ${this.bodyWidth};` + rotateStyle
        : `width: ${this.bodyWidth};height: ${this.bodyHeight}`;
      console.log("rotateStyle", rotateStyle, this.needRotate);
      this.$refs.videoBox.style = rotateStyle;
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="less">
.video-fixed {
  position: fixed;
  width: 100vw;
  height: 100vh;
}
.full-screen-video {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background-color: black;
}
.video-js button {
  outline: none;
}
.logoModalRight {
  position: absolute;
  background: white;
  right: 0;
  top: 0;
}
.video-js {
  max-width: var(--videoWidth) !important;
  max-height: var(--videoHeight) !important;
  height: 100% !important;
  padding-top: 0;
}
.vjs-duration {
  display: block !important;
}

.vjs-current-time {
  display: block !important;
}

.vjs-control-bar {
  pointer-events: auto !important;
}
// -------
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
  display: block;
}
.video-js .vjs-big-play-button {
  /* 中间大的播放按钮 */
  font-size: 2.3em;
  line-height: 2.1em;
  height: 2.3em;
  width: 2.3em;
  border-radius: 2.5em;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  border-width: 0.1em;
  transform: translate(-50%, -50%);
  margin-top: 0;
  margin-left: 0;
}
/* 中间的播放箭头 */
.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.4em;
}
</style>
